/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

// One past/current attempt for a CBQ exam. Scores come back as strings.
export type CBQExamSession = {
  id: string;
  attemptNumber?: number;
  status?: string;
  mode?: string;
  section1Score?: number | string | null;
  section1Passed?: boolean | null;
  section2Score?: number | string | null;
  totalScore?: number | string | null;
  submittedAt?: string | null;
  createdAt?: string | null;
};

type GetCBQExamSessionsResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: CBQExamSession[];
};

// GET /cbq/exams/:cbqExamId/sessions — the student's attempts for an exam.
export const GetCBQExamSessions = async (
  cbqExamId: string
): Promise<GetCBQExamSessionsResponse> => {
  try {
    const response = await axios.get(`/cbq/exams/${cbqExamId}/sessions`);
    const raw = response.data?.data ?? response.data;
    const list: CBQExamSession[] = Array.isArray(raw) ? raw : raw?.data ?? [];
    return { data: list };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      if (error.response.status === 404) {
        return { data: [] };
      }
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
